import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'
import { LocationSearch } from 'Core/utils/storeHelpers/types'

export enum LocationSearchSuggFields {
	searchById = 'searchById',
	searchByName = 'searchByName'
}

export enum LocationFilterFields {
	divisionId = 'divisionId',
	regionId = 'regionId',
	businessUnitId = 'businessUnitId'
}

export enum SelectedFilter {
	onlySelectedLocations = 'OnlySelectedLocations'
}

export enum TagType {
	division,
	region,
	businessUnit
}

export declare namespace Location {
	interface Basic {
		id: number
		companyserviceSiteId: number
		name: string
		address: string
		city: string
		state: string
		country: string
		isSelected: boolean
		sector: string
		region: string
		group: string
		division: string
	}

	interface LocationFilter extends Entity {}

	interface CompanyLocation {
		location: LocationFilter
	}

	interface FilterOptions extends CompanyLocation {
		categories: CodeEntity[]
	}

	namespace Search {
		interface Result {
			[LocationSearchSuggFields.searchById]: LocationSearch[]
			[LocationSearchSuggFields.searchByName]: LocationSearch[]
		}

		interface Config {
			[LocationSearchSuggFields.searchById]: ConfigItem<LocationSearchSuggFields>
			[LocationSearchSuggFields.searchByName]: ConfigItem<LocationSearchSuggFields>
		}
	}
	namespace Filter {
		interface Basic {
			divisionId: BasicString
			regionId: BasicString
			businessUnitId: BasicString
			tagType: TagType
		}
		interface Config {
			[LocationFilterFields.regionId]: ConfigFilterItem<string, null>
			[LocationFilterFields.divisionId]: ConfigFilterItem<string, null>
			[LocationFilterFields.businessUnitId]: ConfigFilterItem<string, null>
		}
	}
	namespace Request {
		interface Add {
			addPreferredServiceSitesIds: number[]
			removePreferredServiceSitesIds: number[]
		}
	}
}
